import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { BarChart3 } from 'lucide-react';
import { DashboardCard } from './DashboardCard';
import { PIE_COLORS, TOOLTIP_ITEM_STYLE, TOOLTIP_STYLE } from './chartTheme';

interface PieChartCardProps {
  title: string;
  data: { name: string; value: number }[];
  icon?: React.ComponentType<{ className?: string }>;
  height?: number;
  className?: string;
  onSliceClick?: (name: string, value: number) => void;
}

export function PieChartCard({
  title,
  data,
  icon = BarChart3,
  height = 240,
  className,
  onSliceClick,
}: PieChartCardProps) {
  if (data.length === 0) return null;

  const handleClick = (entry: { name: string; value: number }) => {
    if (onSliceClick && entry?.name) {
      onSliceClick(entry.name, entry.value);
    }
  };

  return (
    <DashboardCard title={title} icon={icon} className={className}>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={85}
            strokeWidth={2}
            // Traco da cor do cartao entre as fatias: o contraste que decide
            // e o da serie sobre o cartao (tokens.css, --chart-1..6).
            stroke="hsl(var(--card))"
            // Rotulo e texto: vai em --card-foreground, nao na cor da fatia.
            label={({ name, value, x, y, textAnchor }) => (
              <text
                x={x}
                y={y}
                textAnchor={textAnchor}
                dominantBaseline="central"
                fill="hsl(var(--card-foreground))"
              >
                {`${name}: ${value}`}
              </text>
            )}
            style={onSliceClick ? { cursor: 'pointer' } : undefined}
            onClick={handleClick}
          >
            {data.map((_, i) => (
              <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
            ))}
          </Pie>
          <Tooltip contentStyle={TOOLTIP_STYLE} itemStyle={TOOLTIP_ITEM_STYLE} />
          <Legend
            iconType="circle"
            iconSize={8}
            wrapperStyle={{ fontSize: '11px' }}
            // O Recharts pinta o nome com a cor da serie; nome e texto.
            formatter={(nome: string) => <span className="text-card-foreground">{nome}</span>}
          />
        </PieChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
